<template>
  <div>
    <canvas
      ref="boxplotCanvas"
      :height="$vuetify.breakpoint.lgAndUp ? '60px' : '120px'"
    ></canvas>
  </div>
</template>

<script>
import { BoxPlotChart } from "@sgratzl/chartjs-chart-boxplot";
import _ from "lodash";
const COLORS = [
  {
    name: "1/10",
    level: "L10",
    code: "#238100",
  },
  {
    name: "1/30",
    level: "L30",
    code: "#FEFF54",
  },
  {
    name: "1/50",
    level: "L50",
    code: "#FF8038",
  },
  {
    name: "1/100",
    level: "L100",
    code: "#ff1300",
  },
  {
    name: "1/150",
    level: "L150",
    code: "#f027ff",
  },
  {
    name: "1/200",
    level: "L200",
    code: "#880088",
  },
  {
    name: "想定最大規模",
    level: "LMAX",
    code: "#000000",
  },
];

export default {
  name: "BoxplotChart",
  props: ["river"],
  data() {
    return {
      chartData: {
        labels: ["7/24 18:00"],
        datasets: [
          {
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            borderColor: "rgba(75, 192, 192, 1)",
            outlierRadius: 2,
            outlierBackgroundColor: "rgba(75, 192, 192, 1)",
            itemRadius: 2,
            data: null,
          },
        ],
      },
      chartOptions: {
        animation: false,
        indexAxis: "y",
        responsive: true,
        scales: {
          x: {
            display: true,
            max: 1000,
          },
          y: {
            display: true,
          },
        },
        plugins: {
          title: {
            display: true,
            text: "",
          },
          legend: {
            display: false,
          },
          annotation: {
            common: {
              drawTime: "beforeDatasetsDraw",
            },
            annotations: {},
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = "";

                const hoverIndex = context.formattedValue.hoveredOutlierIndex;
                if (hoverIndex !== -1) {
                  label += `${context.formattedValue.outliers[hoverIndex]}mm, `;
                }

                const min = context.formattedValue.min;
                const max = context.formattedValue.max;
                label += `min: ${min}mm, max: ${max}mm`;

                return label;
              },
            },
          },
        },
      },
    };
  },
  created() {
    const forecast = _.sortBy(this.river.forecast);
    const min = forecast[0];
    const q1 = forecast[parseInt(forecast.length * (1 / 4))];
    const median = forecast[parseInt(forecast.length * (2 / 4))];
    const q3 = forecast[parseInt(forecast.length * (3 / 4))];
    const max = forecast[forecast.length - 1];
    this.chartData.datasets[0].data = [
      {
        min,
        q1,
        median,
        q3,
        max,
        whiskerMin: min,
        whiskerMax: max,
        outliers: forecast,
      },
    ];
    this.chartOptions.scales.x.max =
      parseInt(this.getRiverMax() / 100) * 100 + 100;

    if (this.$vuetify.breakpoint.mdAndDown) {
      this.chartData.labels = [""];
      this.chartOptions.plugins.title.text = [
        `アンサンブル${this.river.forecastTime}時間予測累加雨量 [mm]`,
        this.river.forecastBaseDate,
      ];
    } else {
      this.chartData.labels = [this.river.forecastBaseDate];
      this.chartOptions.plugins.title.text = `アンサンブル${this.river.forecastTime}時間累加雨量 [mm]`;
    }

    COLORS.forEach((color, index) => {
      this.chartOptions.plugins.annotation.annotations["box" + (index + 1)] = {
        type: "line",
        borderColor: color.code,
        borderWidth: 1.2,
        scaleID: "x",
        value: this.river[color.level],
        label: {
          display: false,
          drawTime: "afterDatasetsDraw",
          content: () => [`${color.name} : ${this.river[color.level]} mm`],
        },
        enter({ element }) {
          element.label.options.display = true;
          return true;
        },
        leave({ element }) {
          element.label.options.display = false;
          return true;
        },
      };
    });
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      const ctx = this.$refs.boxplotCanvas.getContext("2d");

      new BoxPlotChart(ctx, {
        data: this.chartData,
        options: this.chartOptions,
      });
    },
    getRiverMax() {
      if (this.river.LMAX) {
        return this.river.LMAX;
      } else if (this.river.L200) {
        return this.river.L200;
      } else if (this.river.L150) {
        return this.river.L150;
      } else if (this.river.L100) {
        return this.river.L100;
      } else if (this.river.L50) {
        return this.river.L50;
      } else if (this.river.L30) {
        return this.river.L30;
      } else if (this.river.L10) {
        return this.river.L10;
      }
    },
  },
};
</script>
